module.exports = __webpack_public_path__ + "media/images/flags/1x1/slv-168488f69eee6392aacdaa57d7facd0c.svg";